// Module
var code = "<canvas class=\"signature-pad\" height=\"150\" width=\"800\"></canvas> <div style=\"width:800px;min-height:34px\"> <ng-transclude></ng-transclude> <button type=\"button\" class=\"btn btn-danger pull-right\">Clear</button> &nbsp; </div> ";
// Exports
export default code;